/* ==========================================================================
   Dead Romance — "We buried something for you" SMS dig pop-up

   PORT: this file ships to assets/dr-grave-dig.js UNCHANGED.
   Every tunable is a data-gd-* attribute on the <dialog>, written by Liquid
   from section settings. Nothing commercial or campaign-specific lives here.

   Flow:  trigger (delay / exit intent) -> pick a grave -> dig (canvas scratch)
          -> reveal -> "Claim it" -> window.postscript.popups.open(popupId)
          Postscript owns the phone step, TCPA consent and the unique code.
          If the SDK is missing (blocked/failed), the Claim control is a real
          <a href> to the Postscript keyword link, so it still works.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-dr-grave-dig]');
  if (!root || typeof root.showModal !== 'function') return;

  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  var cfg = {
    popupId:      (root.getAttribute('data-gd-popup-id') || '').trim(),
    delay:        num(root.getAttribute('data-gd-delay'), 6),
    exitIntent:   root.getAttribute('data-gd-exit-intent') === 'true',
    cooldownDays: num(root.getAttribute('data-gd-cooldown-days'), 7),
    threshold:    num(root.getAttribute('data-gd-threshold'), 0.5),
    force:        /[?&]dr_dig=1\b/.test(location.search)
  };

  var KEY = 'dr_grave_dig_v1';
  function readState() {
    try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; }
  }
  function writeState(patch) {
    try {
      var s = readState();
      for (var k in patch) s[k] = patch[k];
      localStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) { /* private mode / blocked storage: fail open, never break the page */ }
  }

  function emit(action, extra) {
    var detail = { action: action };
    if (extra) for (var k in extra) detail[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent('dr:grave-dig', { detail: detail })); } catch (e) {}
  }

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer  = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------- gating */

  function suppressedLocally() {
    if (cfg.force) return false;
    if (/utm_source=postscript/i.test(location.search)) return true;   // came from one of our texts
    var s = readState();
    if (s.claimed) return true;
    if (s.dismissed && Date.now() - s.dismissed < cfg.cooldownDays * 864e5) return true;
    return false;
  }

  // getSubscriberId may be sync or a promise depending on SDK build — handle both.
  function isSubscriber(cb) {
    var ps = window.postscript, r;
    if (!ps || typeof ps.getSubscriberId !== 'function') return cb(false);
    try { r = ps.getSubscriberId(); } catch (e) { return cb(false); }
    if (r && typeof r.then === 'function') {
      var done = false;
      r.then(function (id) { if (!done) { done = true; cb(!!id); } },
             function ()   { if (!done) { done = true; cb(false); } });
      setTimeout(function () { if (!done) { done = true; cb(false); } }, 1500);
    } else {
      cb(!!r);
    }
  }

  function anotherDialogOpen() {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) if (open[i] !== root) return true;
    return false;
  }

  var shown = false, timer = null;

  function tryOpen() {
    if (shown) return;
    if (anotherDialogOpen()) { timer = setTimeout(tryOpen, 4000); return; } // don't stack on the cart
    isSubscriber(function (sub) {
      if (sub && !cfg.force) return;
      open();
    });
  }

  function onExit(e) {
    if (e.relatedTarget == null && e.clientY <= 0) {
      document.removeEventListener('mouseout', onExit);
      clearTimeout(timer);
      tryOpen();
    }
  }

  function arm() {
    var s = readState();
    if (!cfg.force && s.claimed) return;                 // claimed: never again, no tab
    if (tabWanted(s)) showTab(true);
    if (suppressedLocally()) return;
    setTimeout(warmPhoto, Math.max(0, cfg.delay - 3) * 1000);   // fetch the scene just before it can open
    if (cfg.delay >= 0) timer = setTimeout(tryOpen, cfg.delay * 1000);
    if (cfg.exitIntent && finePointer) document.addEventListener('mouseout', onExit);
  }

  /* ------------------------------------------------------------ open/close */

  var yard     = root.querySelector('[data-gd-yard]');
  var plots    = Array.prototype.slice.call(root.querySelectorAll('[data-gd-plot]'));
  var shovel   = root.querySelector('[data-gd-shovel]');
  var fx       = root.querySelector('[data-gd-fx]');
  var fxCtx    = fx ? fx.getContext('2d') : null;
  var claimEl  = root.querySelector('[data-gd-claim]');
  var claimed  = false;
  var picked   = null;
  var finished = false;
  var keyboardUser = false;   // move focus to Claim only for keyboard users — no stray ring on touch
  root.addEventListener('keydown', function () { keyboardUser = true; }, true);
  root.addEventListener('pointerdown', function () { keyboardUser = false; }, true);

  function setState(s) { root.setAttribute('data-gd-state', s); }

  function open() {
    shown = true;
    clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
    hideTab();
    setState(finished ? 'done' : 'dig');
    root.showModal();
    root.focus({ preventScroll: true });   // land on the dialog, not the close button
    writeState({ shown: Date.now() });
    // layout exists only after showModal — paint on the next frame
    requestAnimationFrame(function () {
      sizeFx();
      whenPhoto(function () {                          // soil canvases are cut from the photo
        plots.forEach(paintDirt);
        yard.classList.add('is-ready');
        var dug = readState().dug;                     // dug on an earlier page: no re-dig
        if (!finished && dug && plots[dug - 1]) revealInstant(plots[dug - 1]);
      });
    });
    emit('open');
  }

  // Straight to the revealed letter, no animation (a returning digger).
  function revealInstant(plot) {
    root.classList.add('is-instant');
    pick(plot);
    finished = true;
    plot.classList.add('is-dug');
    var prize = root.querySelector('[data-gd-prize][data-gd-g="' + plot.getAttribute('data-gd-g') + '"]');
    if (prize) prize.classList.add('is-raised');
    setState('done');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('is-instant'); }); });
  }

  /* ------------------------------------------------- reopen tab (right edge)
     After "No thanks" a small tab stays on the page edge so the game can be
     reopened. Mid-height on the right: clear of sticky bars and left-aligned text. */
  var tab = document.querySelector('[data-gd-tab]');

  function tabWanted(s) {
    if (!tab || s.claimed || !s.dismissed) return false;
    if (/utm_source=postscript/i.test(location.search)) return false;
    return !(s.tabHidden && Date.now() - s.tabHidden < cfg.cooldownDays * 864e5);
  }
  function showTab(checkSubscriber) {
    if (!tab || claimed) return;
    warmPhoto();
    tab.setAttribute('data-gd-dug', readState().dug ? 'true' : 'false');
    function reveal() { tab.hidden = false; if (tab._queueTuck) tab._queueTuck(); }
    if (!checkSubscriber) return reveal();
    isSubscriber(function (sub) { if (!sub) reveal(); });
  }
  function hideTab() { if (tab) tab.hidden = true; }

  if (tab) {
    tab.querySelector('[data-gd-tab-open]').addEventListener('click', function () {
      emit('tab-open');
      if (!root.open) open();
    });
    tab.querySelector('[data-gd-tab-close]').addEventListener('click', function () {
      writeState({ tabHidden: Date.now() });
      hideTab();
      emit('tab-hide');
    });
    // the SDK can load after the tab is shown — hide it if this is a known subscriber
    window.addEventListener('postscriptReady', function () {
      isSubscriber(function (sub) { if (sub) hideTab(); });
    });

    // Never sit on top of a way to pay: while the tab overlaps an add-to-cart, express
    // checkout (Shop Pay / Apple Pay) or a sticky buy bar, it tucks off the screen edge.
    var BUY = 'form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], ' +
              '.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, ' +
              '[class*="sticky-atc"], [data-sticky-atc]';
    var tuckQueued = false;
    function overlaps(a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; }
    function tuck() {
      tuckQueued = false;
      if (tab.hidden) return;
      // The resting box is computed, never measured: mid-slide the live rect is wherever the
      // transition has got to. Fixed to the right edge at 56% height (CSS), plus the x badge
      // that overhangs 11px above/left.
      var w = tab.offsetWidth, h = tab.offsetHeight, cy = window.innerHeight * .56;
      var r = { left: document.documentElement.clientWidth - w - 11, right: window.innerWidth,
                top: cy - h / 2 - 11, bottom: cy + h / 2 };
      var hit = false, els = document.querySelectorAll(BUY);
      for (var i = 0; i < els.length && !hit; i++) {
        var e = els[i].getBoundingClientRect();
        if (e.width && e.height && overlaps(r, e)) hit = true;
      }
      tab.classList.toggle('is-tucked', hit);
    }
    function queueTuck() { if (!tuckQueued) { tuckQueued = true; requestAnimationFrame(tuck); } }
    window.addEventListener('scroll', queueTuck, { passive: true });
    window.addEventListener('resize', queueTuck);
    tab._queueTuck = queueTuck;
  }

  root.addEventListener('close', function () {
    if (!claimed) {
      writeState({ dismissed: Date.now() });
      emit('dismiss', { dug: finished });
      showTab(false);
    }
  });
  root.addEventListener('click', function (e) {
    if (e.target === root) root.close();                         // backdrop click
    if (e.target.closest('[data-gd-close]')) root.close();
  });

  /* ------------------------------------------------------------------ dirt
     The scene is a photograph. Over each grave's floor (scene SVG) sit:
       subsoil canvas (.dr-gd__dirt--deep)  the photo's own soil, pressed darker = damp earth below
       topsoil canvas (.dr-gd__dirt--top)   the photo's own mound pixels: seamless until dug
     A scoop cuts a wide ragged bite out of the topsoil and a narrower one, nearer
     the viewer, out of the subsoil: torn lip, shadowed far wall, then the floor.
     Progress is measured on a private mask canvas that never touches the photo,
     so it can always be read back (no cross-origin taint, even from file://). */

  var SOIL = ['#3e3029', '#2f241e', '#4a3a30', '#241b16', '#57463a'];   // sampled from the photo's mounds
  var photo = root.querySelector('[data-gd-photo]');
  var soilPat = null;

  // The photo is only fetched shortly before the pop-up can appear, never on every page view.
  // One plain src, chosen here — NOT srcset: a srcset image reports a density-corrected
  // naturalWidth, which throws off every crop the soil canvases take from it.
  function warmPhoto() {
    if (!photo || photo.getAttribute('src')) return;
    var need = Math.min(window.innerWidth, 600) * Math.min(window.devicePixelRatio || 1, 2);
    var sm = photo.getAttribute('data-src-sm');
    photo.setAttribute('src', sm && need <= 760 ? sm : photo.getAttribute('data-src'));
  }
  function whenPhoto(cb) {
    warmPhoto();
    if (!photo || (photo.complete && photo.naturalWidth)) return cb();
    var done = false;
    function go() { if (!done) { done = true; cb(); } }
    photo.addEventListener('load', go);
    photo.addEventListener('error', go);
  }
  function hasPhoto() { return photo && photo.complete && photo.naturalWidth > 0; }

  function sizeCanvas(c) {
    var r = c.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = Math.max(1, Math.round(r.width * dpr));
    c.height = Math.max(1, Math.round(r.height * dpr));
    return { x: c.getContext('2d'), w: c.width, h: c.height, dpr: dpr };
  }

  // the plot's box, in the photo's natural pixels (data-gd-src = normalised x,y,w,h)
  function srcRect(plot) {
    var v = (plot.getAttribute('data-gd-src') || '0,0,1,1').split(',').map(parseFloat);
    var W = photo.naturalWidth, H = photo.naturalHeight;
    return [v[0] * W, v[1] * H, v[2] * W, v[3] * H];
  }

  function clod(x, cx, cy, rx, ry, rot, body, lit) {
    x.globalAlpha = .6; x.fillStyle = '#0c0907';
    x.beginPath(); x.ellipse(cx + rx * .25, cy + ry * .55, rx, ry, rot, 0, 6.283); x.fill();
    x.globalAlpha = 1; x.fillStyle = body;
    x.beginPath(); x.ellipse(cx, cy, rx, ry, rot, 0, 6.283); x.fill();
    x.globalAlpha = .35; x.fillStyle = lit;
    x.beginPath(); x.ellipse(cx - rx * .2, cy - ry * .35, rx * .55, ry * .35, rot, 0, 6.283); x.fill();
    x.globalAlpha = 1;
  }

  function paintTop(s, plot) {
    if (hasPhoto()) {
      var r = srcRect(plot);
      s.x.drawImage(photo, r[0], r[1], r[2], r[3], 0, 0, s.w, s.h);
    } else {
      s.x.fillStyle = SOIL[1]; s.x.fillRect(0, 0, s.w, s.h);
    }
  }

  function paintDeep(s, plot) {
    var x = s.x, w = s.w, h = s.h, dpr = s.dpr, i, sx, sy, g;
    paintTop(s, plot);                                   // the same soil...
    x.globalCompositeOperation = 'multiply';             // ...pressed darker and damper
    x.fillStyle = '#6a5446'; x.fillRect(0, 0, w, h);
    x.globalCompositeOperation = 'source-over';
    g = x.createLinearGradient(0, 0, 0, h);
    g.addColorStop(0, 'rgba(6,4,3,.5)'); g.addColorStop(1, 'rgba(6,4,3,.18)');
    x.fillStyle = g; x.fillRect(0, 0, w, h);
    x.strokeStyle = '#8a7360'; x.lineWidth = dpr * .7; x.globalAlpha = .4;    // fine roots in the wall
    for (i = 0; i < 9; i++) {
      sx = Math.random() * w; sy = Math.random() * h;
      x.beginPath(); x.moveTo(sx, sy);
      x.quadraticCurveTo(sx + (Math.random() - .5) * 14 * dpr, sy + 6 * dpr, sx + (Math.random() - .5) * 20 * dpr, sy + (8 + Math.random() * 10) * dpr);
      x.stroke();
    }
    x.globalAlpha = 1;
  }

  // a scrap of the photo's soil, used to texture the clods on the spoil pile
  function makeSoilPattern(plot) {
    if (soilPat || !hasPhoto() || !spoilCtx) return;
    var r = srcRect(plot), c = document.createElement('canvas');
    c.width = c.height = 96;
    c.getContext('2d').drawImage(photo, r[0] + r[2] * .35, r[1] + r[3] * .45, r[2] * .25, r[2] * .25, 0, 0, 96, 96);
    soilPat = spoilCtx.createPattern(c, 'repeat');
  }

  function paintDirt(plot) {
    if (plot.classList.contains('is-dug')) return;
    var top = sizeCanvas(plot.querySelector('.dr-gd__dirt--top'));
    var deep = sizeCanvas(plot.querySelector('.dr-gd__dirt--deep'));
    paintTop(top, plot); paintDeep(deep, plot);
    makeSoilPattern(plot);
    var m = document.createElement('canvas');
    m.width = top.w; m.height = top.h;
    plot._gd = { top: top.x, deep: deep.x, mask: m.getContext('2d'), w: top.w, h: top.h, dpr: top.dpr,
                 last: null, lastT: 0, lastMeasure: 0, scoops: 0, inside: insideMap(plot, top.w, top.h) };
  }

  // sample points of the plot box that lie inside the measured mound outline
  var STEP = 4;
  function insideMap(plot, w, h) {
    var raw = (plot.getAttribute('data-gd-poly') || '').trim(), pts = [], out = [], x, y;
    if (raw) pts = raw.split(/\s+/).map(function (p) { var a = p.split(','); return [a[0] * w, a[1] * h]; });
    for (y = 0; y < h; y += STEP) {
      for (x = 0; x < w; x += STEP) {
        if (!pts.length || inPoly(x, y, pts)) out.push(y * w + x);
      }
    }
    return out;
  }
  function inPoly(x, y, p) {
    for (var i = 0, j = p.length - 1, c = false; i < p.length; j = i++) {
      if ((p[i][1] > y) !== (p[j][1] > y) && x < (p[j][0] - p[i][0]) * (y - p[i][1]) / (p[j][1] - p[i][1]) + p[i][0]) c = !c;
    }
    return c;
  }

  function toCanvas(plot, clientX, clientY) {
    var c = plot.querySelector('canvas'), r = c.getBoundingClientRect();
    return { x: (clientX - r.left) * (c.width / r.width), y: (clientY - r.top) * (c.height / r.height) };
  }

  // ragged shovel-bite outline, squashed for the 3/4 view
  function bitePts(cx, cy, r, sq, rot) {
    var k = 12, cos = Math.cos(rot), sin = Math.sin(rot), pts = [];
    for (var i = 0; i < k; i++) {
      var a = i / k * 6.283, rr = r * (.78 + Math.random() * .34);
      var px = Math.cos(a) * rr, py = Math.sin(a) * rr * sq;
      pts.push([cx + px * cos - py * sin, cy + px * sin + py * cos]);
    }
    return pts;
  }
  function trace(x, pts) {
    x.beginPath();
    for (var i = 0; i < pts.length; i++) { if (i) x.lineTo(pts[i][0], pts[i][1]); else x.moveTo(pts[i][0], pts[i][1]); }
    x.closePath();
  }

  function scoop(plot, pt) {
    var d = plot._gd; if (!d) return;
    var R = d.w * (finePointer ? .25 : .28), sq = .72, rot = (Math.random() - .5) * .6, i, a, rr, g;
    var t = d.top, k = d.deep, m = d.mask;
    var outer = bitePts(pt.x, pt.y, R, sq, rot);
    var inner = bitePts(pt.x + (Math.random() - .5) * R * .15, pt.y + R * sq * .2, R * .78, sq, rot);

    // 1. topsoil: wide bite, then loose crumbs + a dark lip on what remains
    t.globalCompositeOperation = 'destination-out';
    t.fillStyle = '#000';                          // erase strength = fill alpha: must be opaque
    trace(t, outer); t.fill();
    t.globalCompositeOperation = 'source-atop';
    for (i = 0; i < 16; i++) {
      a = Math.random() * 6.283; rr = R * (.92 + Math.random() * .4);
      t.globalAlpha = .8;
      t.fillStyle = Math.random() < .5 ? '#6a5848' : '#120d0a';
      t.beginPath();
      t.ellipse(pt.x + Math.cos(a) * rr, pt.y + Math.sin(a) * rr * sq, d.dpr * (.8 + Math.random() * 1.6), d.dpr * (.6 + Math.random()), 0, 0, 6.283);
      t.fill();
    }
    t.globalAlpha = .55; t.strokeStyle = '#0a0705'; t.lineWidth = d.dpr * 2.2;
    trace(t, bitePts(pt.x, pt.y + d.dpr, R * 1.03, sq, rot)); t.stroke();
    t.globalAlpha = 1; t.globalCompositeOperation = 'source-over';

    // 2. subsoil: shade the far wall, then cut the deeper, narrower bite nearer the viewer
    k.globalCompositeOperation = 'source-atop';
    g = k.createLinearGradient(0, pt.y - R * sq, 0, pt.y + R * sq * .4);
    g.addColorStop(0, 'rgba(0,0,0,.55)'); g.addColorStop(1, 'rgba(0,0,0,0)');
    k.fillStyle = g; trace(k, outer); k.fill();
    k.globalCompositeOperation = 'destination-out';
    k.fillStyle = '#000';                          // the wall gradient above is semi-transparent
    trace(k, inner); k.fill();
    k.globalCompositeOperation = 'source-over';

    // 3. progress mask: same deep bite, opaque
    m.fillStyle = '#000'; trace(m, inner); m.fill();
    d.scoops++;
  }

  // Share of the visible mound dug down to the floor, inside the measured outline only.
  function clearedRatio(plot) {
    var d = plot._gd; if (!d || !d.inside.length) return 0;
    var data = d.mask.getImageData(0, 0, d.w, d.h).data, clear = 0;
    for (var i = 0; i < d.inside.length; i++) if (data[d.inside[i] * 4 + 3] >= 128) clear++;
    return clear / d.inside.length;
  }

  function maybeFinish(plot, force) {
    var d = plot._gd; if (!d || finished) return;
    var now = Date.now();
    if (!force && now - d.lastMeasure < 120) return;
    d.lastMeasure = now;
    if (clearedRatio(plot) >= cfg.threshold) finish(plot);
  }

  function finish(plot) {
    if (finished) return;
    finished = true;
    dragging = false;
    plot.classList.add('is-dug');
    var prize = root.querySelector('[data-gd-prize][data-gd-g="' + plot.getAttribute('data-gd-g') + '"]');
    if (prize) setTimeout(function () { prize.classList.add('is-raised'); }, reduceMotion ? 0 : 380);  // soil clears, then the letter rises
    setTimeout(shovelOff, 320);
    for (var i = 0; i < 4; i++) toss(plot, centerOf(plot), 1);   // last shovelfuls onto the pile
    writeState({ dug: plots.indexOf(plot) + 1 });   // a reopen skips straight to the letter
    emit('dug', { grave: plots.indexOf(plot) + 1 });
    setTimeout(function () {
      setState('done');
      if (!claimEl) return;
      if (keyboardUser) claimEl.focus();
      else claimEl.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
    }, reduceMotion ? 0 : 900);
  }

  function pick(plot) {
    if (picked && picked !== plot) return false;
    if (!picked) {
      picked = plot;
      // the other graves sink into shadow across all scene layers
      var g = plot.getAttribute('data-gd-g');
      Array.prototype.forEach.call(root.querySelectorAll('[data-gd-g]'), function (el) {
        if (el.getAttribute('data-gd-g') !== g) el.classList.add('is-faded');
      });
      emit('pick', { grave: plots.indexOf(plot) + 1 });
    }
    return true;
  }

  /* ---------------------------------------------------------------- shovel */

  function yardPoint(clientX, clientY) {
    var r = yard.getBoundingClientRect();
    return { x: clientX - r.left, y: clientY - r.top };
  }
  function centerOf(plot) {
    var p = plot.getBoundingClientRect(), y = yard.getBoundingClientRect();
    return { x: p.left - y.left + p.width / 2, y: p.top - y.top + p.height * .55 };
  }
  function moveShovel(p) {
    if (!shovel) return;
    shovel.style.transform = 'translate(' + p.x + 'px,' + p.y + 'px)';
  }
  var hideT = 0;
  function shovelOn()  { clearTimeout(hideT); if (shovel && !finished) shovel.classList.add('is-on'); }
  function shovelOff() { if (shovel) shovel.classList.remove('is-on'); }
  function shovelHideSoon() { clearTimeout(hideT); hideT = setTimeout(shovelOff, 420); }  // let the flick finish on touch

  function restart(el, cls) {
    if (!el || reduceMotion) return;
    el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls);
  }

  function shovelful(plot, pt, yp) {
    scoop(plot, pt);
    restart(shovel, 'is-scoop');                 // plunge, lever back, flick
    restart(plot, 'is-jolt');                    // the ground takes the hit
    try { if (!finePointer && navigator.vibrate) navigator.vibrate(8); } catch (e) {}
    toss(plot, yp, 4);
    maybeFinish(plot, false);
  }

  /* ------------------------------------------- thrown dirt + the spoil pile */

  var spoil = root.querySelector('[data-gd-spoil]');
  var spoilCtx = spoil ? spoil.getContext('2d') : null;
  var PAD = 40;                                   // fx + spoil canvases overhang the yard by 40px
  var parts = [], raf = 0, pile = { n: 0, x: 0, y: 0, set: false };

  function sizeLayer(c, ctx) {
    if (!c) return;
    var r = c.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = Math.round(r.width * dpr); c.height = Math.round(r.height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function sizeFx() { sizeLayer(fx, fxCtx); sizeLayer(spoil, spoilCtx); pile.set = false; }

  // pile sits on the lawn at the grave's front corner facing the middle of the yard
  function pileSpot(plot) {
    var p = plot.getBoundingClientRect(), y = yard.getBoundingClientRect();
    var mid = p.left + p.width / 2 < y.left + y.width * .66;
    var x = mid ? p.right - y.left - p.width * .02 : p.left - y.left + p.width * .02;
    return { x: x + PAD, y: p.bottom - y.top - p.height * .04 + PAD };
  }

  function stamp(x, y) {
    if (!spoilCtx) return;
    var u = Math.max(1, yard.clientWidth / 540), r;
    if (!pile.set) {                               // contact shadow, once
      spoilCtx.globalAlpha = .55; spoilCtx.fillStyle = '#050403';
      spoilCtx.beginPath(); spoilCtx.ellipse(pile.x, pile.y + 2 * u, 28 * u, 7 * u, 0, 0, 6.283); spoilCtx.fill();
      spoilCtx.globalAlpha = 1; pile.set = true;
    }
    r = (2.2 + Math.random() * 3.2) * u;
    clod(spoilCtx, x, y, r, r * .7, Math.random() * 3, soilPat || SOIL[(Math.random() * 5) | 0], '#7a6656');
  }

  function land(p) {
    // each landing builds the heap up and out a little
    var lift = Math.min(pile.n * .5, 16), spread = 9 + Math.min(pile.n * .55, 15);
    var gx = (Math.random() + Math.random() - 1) * spread, gy = (Math.random() + Math.random() - 1) * spread * .35;
    stamp(pile.x + gx, pile.y - lift * (1 - Math.abs(gx) / (spread + 1)) + gy);
    pile.n++;
  }

  function toss(plot, from, clumps) {
    var to = pileSpot(plot);
    if (!pile.n) { pile.x = to.x; pile.y = to.y; }
    if (reduceMotion || !fxCtx) { for (var j = 0; j < clumps; j++) land(); return; }
    var i, T, G = .38, sx = from.x + PAD, sy = from.y + PAD;
    for (i = 0; i < clumps; i++) {                // clumps fly in an arc and land on the pile
      T = 22 + Math.random() * 8;
      var tx = pile.x + (Math.random() - .5) * 10, ty = pile.y - Math.min(pile.n * .5, 16);
      parts.push({ x: sx, y: sy, vx: (tx - sx) / T, vy: (ty - sy) / T - .5 * G * T, g: G, t: 0, T: T,
                   s: 2.2 + Math.random() * 2.4, c: SOIL[(Math.random() * 5) | 0], clump: true, life: 1 });
    }
    for (i = 0; i < 7; i++) {                     // loose crumbs that scatter and fade
      parts.push({ x: sx, y: sy, vx: (to.x - sx) / 30 + (Math.random() - .5) * 3, vy: -2 - Math.random() * 3.5, g: .3,
                   t: 0, T: 1e9, s: .8 + Math.random() * 1.4, c: SOIL[(Math.random() * SOIL.length) | 0], life: 1 });
    }
    if (!raf) raf = requestAnimationFrame(tick);
  }

  function tick() {
    var r = fx.getBoundingClientRect();
    fxCtx.clearRect(0, 0, r.width, r.height);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.vy += p.g; p.x += p.vx; p.y += p.vy; p.t++;
      if (p.clump && p.t >= p.T) { land(p); parts.splice(i, 1); continue; }
      if (!p.clump) { p.life -= .03; if (p.life <= 0) { parts.splice(i, 1); continue; } }
      fxCtx.globalAlpha = p.life;
      fxCtx.fillStyle = p.c;
      fxCtx.beginPath(); fxCtx.ellipse(p.x, p.y, p.s, p.s * .75, p.t * .2, 0, 6.283); fxCtx.fill();
    }
    fxCtx.globalAlpha = 1;
    raf = parts.length ? requestAnimationFrame(tick) : 0;
  }

  /* -------------------------------------------------------- pointer + touch
     Pointer Events cover mouse, finger and pen alike. Tap a mound = one
     shovelful. Drag across it = a shovelful every short stretch of travel.
     A drag may start on the grass; digging starts once over a mound.      */

  var active = null, dragging = false;

  function plotAt(clientX, clientY) {
    var el = document.elementFromPoint(clientX, clientY);   // clip-path aware hit test
    return el && el.closest ? el.closest('[data-gd-plot]') : null;
  }

  function dig(e, first) {
    var under = plotAt(e.clientX, e.clientY);
    if (!active) {
      if (!under || !pick(under)) return;
      active = under; first = true;
    }
    if (under !== active) return;
    var d = active._gd; if (!d) return;
    var pt = toCanvas(active, e.clientX, e.clientY), now = performance.now();
    if (!first && d.last && (Math.hypot(pt.x - d.last.x, pt.y - d.last.y) < d.w * .12 || now - d.lastT < 90)) return;
    d.last = pt; d.lastT = now;
    shovelful(active, pt, yardPoint(e.clientX, e.clientY));
  }

  yard.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') shovelOn(); });
  yard.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && !dragging) shovelOff(); });

  yard.addEventListener('pointermove', function (e) {
    moveShovel(yardPoint(e.clientX, e.clientY));
    if (dragging && !finished) dig(e, false);
  });

  yard.addEventListener('pointerdown', function (e) {
    if (finished || e.button > 0) return;
    e.preventDefault();
    dragging = true;
    try { yard.setPointerCapture(e.pointerId); } catch (err) {}
    moveShovel(yardPoint(e.clientX, e.clientY)); shovelOn();
    dig(e, true);
  });

  function endDig(e) {
    if (!dragging) return;
    dragging = false;
    if (e.pointerType !== 'mouse') shovelHideSoon();
    if (active) maybeFinish(active, true);
    active = null;
  }
  yard.addEventListener('pointerup', endDig);
  yard.addEventListener('pointercancel', endDig);

  /* --------------------------------------------- "dig it up for me" (a11y) */

  function autoDig(plot) {
    if (finished || autoDig.running) return;
    plot = plot || picked || plots[(Math.random() * plots.length) | 0];
    if (!pick(plot)) plot = picked;
    if (!plot._gd) paintDirt(plot);
    var d = plot._gd, i = 0, pr = plot.getBoundingClientRect(), yr = yard.getBoundingClientRect();
    // shovelfuls in a serpentine over the mound, then extra ones until it's dug
    var path = [], rows = 3, cols = 3, r, c;
    for (r = 0; r < rows; r++) for (c = 0; c < cols; c++) {
      var cc = r % 2 ? cols - 1 - c : c;
      path.push({ u: .24 + cc * .26 + (Math.random() - .5) * .06, v: .3 + r * .24 + (Math.random() - .5) * .05 });
    }
    autoDig.running = true;
    shovelOn();
    (function next() {
      if (finished || i > 40) { autoDig.running = false; return; }
      var p = path[i] || { u: .2 + Math.random() * .6, v: .25 + Math.random() * .6 };
      i++;
      var pt = { x: d.w * p.u, y: d.h * p.v };
      var yp = { x: pr.left - yr.left + p.u * pr.width, y: pr.top - yr.top + p.v * pr.height };
      moveShovel(yp);
      shovelful(plot, pt, yp);
      maybeFinish(plot, true);
      setTimeout(next, reduceMotion ? 0 : 150);
    })();
  }

  root.addEventListener('keydown', function (e) {
    var plot = e.target.closest && e.target.closest('[data-gd-plot]');
    if (plot && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); autoDig(plot); }
  });
  var autoBtn = root.querySelector('[data-gd-auto]');
  autoBtn && autoBtn.addEventListener('click', function () { autoDig(null); });

  /* ----------------------------------------------------------------- claim */

  // Decide synchronously, inside the tap: by the time anyone has dug a grave
  // (open delay + digging) Postscript's async SDK has long since loaded, so if it
  // is missing now it is blocked. The fallback must stay a native link tap —
  // iOS only hands an sms: redirect to Messages from a real user gesture.
  claimEl && claimEl.addEventListener('click', function (e) {
    claimed = true;
    writeState({ claimed: Date.now() });
    var ps = window.postscript, handedOff = false;
    if (cfg.popupId && ps && ps.popups && typeof ps.popups.open === 'function') {
      try {
        ps.popups.open(cfg.popupId, { activePopupBehavior: 'ALWAYS_DISMISS', respectPopupStatus: false });
        handedOff = true;
      } catch (err) { handedOff = false; }
    }
    emit('claim', { via: handedOff ? 'postscript-popup' : 'keyword-link' });
    hideTab();
    if (handedOff) { e.preventDefault(); root.close(); }   // our modal leaves the top layer; Postscript's form shows
    // else: the control is a real <a href> to the Postscript keyword link — let it navigate.
  });

  window.addEventListener('resize', function () {
    if (!root.open) return;
    sizeFx();
    plots.forEach(function (p) { if (!p._gd || (!p._gd.scoops && p !== picked)) paintDirt(p); });
  });

  // QA hooks: ?dr_dig=1 forces it; DR_GRAVE_DIG.reset() clears the once-per-visitor memory.
  window.DR_GRAVE_DIG = {
    open: function () { if (!root.open) open(); },
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };

  arm();
})();
